<script>

    import { import_all, export_all, list_notebooks } from '../controller.js'
    import page from 'page'
    import Nav from '../components/Nav.svelte'
    import { Syncer } from '../sync.js'

    function do_export() {
        let data = export_all()

        let a = document.createElement("a")
        a.href = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));
        console.log(a.href)
        a.setAttribute("download", "dnd_notes.json")
        a.click()
        a.remove()
    }

    async function do_import() {
        const file_picker = document.getElementById("import_file")
        let data = await file_picker.files[0].text()
        console.log(data)
        try {
            import_all(data)
            page('/')
        } catch(error) {
            alert("Error loading data: " + error)
        }
    }

    let syncIdentifier = window.localStorage.getItem("syncIdentifier");
    async function sync_load() {
        if (syncIdentifier == null || syncIdentifier.trim() == "") {
            alert("Please specify an identifier to use for syncing")
            return;
        }
        if (!confirm("Are you sure you want to load? This will overwrite your local data!")) {
            return;
        }
        Syncer.setIdentifier(syncIdentifier);
        Syncer.load((synced_notebooks) => {
            try {
                import_all(JSON.stringify(synced_notebooks))
                page('/')
            } catch(error) {
                alert("Error loading data: " + error)
            }
        })
        /*
        let response = await fetch(`${SYNC_URL}/get`, {
            method: 'POST',
            headers: {"Content-type": "application/json; charset=UTF-8"},
            body: JSON.stringify(
                {'token': token, 'name': 'dnd-notes.json'}
            ),
        })
        let data = await response.json()
        */
    }
    function sync_save() {
        Syncer.setIdentifier(syncIdentifier);
        Syncer.save(list_notebooks());
    }
</script>

<Nav />

<input
    type="file"
    id="import_file"
    accept="json/*"
    style="display:none"
    on:change={do_import}
>
<h2>Import / Export</h2>
<button on:click="{e => document.getElementById('import_file').click()}">
    Import Data File
</button>
<button on:click={do_export}>Export Data</button>

<h2>Cloud Sync</h2>
<input bind:value={syncIdentifier}>
<br>
<button on:click={sync_load}>Load From Cloud</button>
<button on:click={sync_save}>Save To Cloud</button>
